import { useMutation } from '@tanstack/react-query'

import { Token } from '../../@types'
import { login, LoginInfo } from '../../api'


interface UseLoginParams {
  onSuccess: (tokens: Token, variables: LoginInfo, context: unknown) => void
  onError: (errors: unknown, variables: LoginInfo, context: unknown) => void
}

const useLogin = ({onSuccess, onError}: UseLoginParams) => {
  return useMutation({
    mutationFn: (loginInfo: LoginInfo) => login(loginInfo),
    onSuccess,
    onError,
  })
}

export default useLogin
